export default __webpack_public_path__ + "static/media/second-slide-bg.14ad67d9.png";